export const MODAL_TYPES = Object.freeze({
    INFO: "INFO",
    CONFIRM: "CONFIRM",
    SELECT: "SELECT",
    OK: "OK",
});
